import { render, staticRenderFns } from "./LocationCustomFieldModal.vue?vue&type=template&id=6d96f950"
import script from "./LocationCustomFieldModal.vue?vue&type=script&lang=ts"
export * from "./LocationCustomFieldModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports